var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { FormattedMessage, FormattedCurrency, injectIntl } from "@irati/utils/lang";
import connect from "@irati/store/connect";
import id from "@irati/utils/id";
import RewardWalletBalanceQuery from "@irati/wallet/apollo/query/RewardWallet";
import RewardsQueryComponent from "@irati/reward/apollo/query/Rewards";
import { RewardStatus } from "@irati/reward/enums";
import tracking from "@irati-tracking/wallet/rewardWallet";
import { H3 } from "@irati/ui/src/Headings";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import { CreditWrapper, CreditAsRewardWrapper, Balances, Balance, StyledButton, StyledCard, StyledCaption, AvailableBalance } from "./styled";
var RewardWalletBannerCard = /** @class */ (function (_super) {
    __extends(RewardWalletBannerCard, _super);
    function RewardWalletBannerCard() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.returnVariables = function () { return ({
            limit: 12,
            status: RewardStatus.ON,
            sortBy: "createdAt",
            sortDir: "DESC",
            rewardsForMyPackage: true,
            isCreditOnly: true
        }); };
        _this.returnCreditReward = function (_a) {
            var rewardCatalogueRewards = _a.rewardCatalogueRewards;
            var results = rewardCatalogueRewards.results;
            if (results.length > 0) {
                var creditReward = results[0];
                return creditReward;
            }
            return undefined;
        };
        _this.handleSendCredit = function () {
            tracking.startRewardWalletSendCredit();
        };
        return _this;
    }
    RewardWalletBannerCard.prototype.render = function () {
        var _this = this;
        var isMobile = this.props.isMobile;
        var IconSize = isMobile ? 20 : 25;
        var idNamespace = id("reward-wallet-banner", this.props);
        var variables = this.returnVariables();
        return (React.createElement(RewardWalletBalanceQuery, null, function (_a) {
            var data = _a.data;
            var _b = data.rewardWallet, availableBalance = _b.availableBalance, currency = _b.currency;
            var hasBalance = availableBalance > 0;
            if (!hasBalance) {
                return null;
            }
            return (React.createElement(RewardsQueryComponent, { variables: variables }, function (res) {
                var creditReward = _this.returnCreditReward(res.data);
                return (React.createElement(StyledCard, { id: idNamespace },
                    React.createElement(CreditWrapper, { fullWidth: !creditReward },
                        React.createElement(Balances, null,
                            React.createElement(Balance, { id: id("available-balance", idNamespace) },
                                React.createElement(H3, { bold: true },
                                    React.createElement(Icon, { icon: IconTypes.wallet, size: IconSize, marginRight: true }),
                                    React.createElement(FormattedMessage, { id: "reward.banner.wallet.header" })),
                                React.createElement(StyledCaption, { flush: true },
                                    React.createElement(FormattedMessage, { id: "reward.banner.wallet.available" })),
                                React.createElement(AvailableBalance, null,
                                    React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: availableBalance }))))),
                    creditReward &&
                        React.createElement(CreditAsRewardWrapper, null,
                            React.createElement(StyledButton, { primary: true, to: "/reward/" + creditReward.urlSlug, onClick: _this.handleSendCredit },
                                React.createElement(FormattedMessage, { id: "reward.banner.wallet.sendLink" })))));
            }));
        }));
    };
    return RewardWalletBannerCard;
}(PureComponent));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isMobile: mq.lessThan.md
    });
};
export default injectIntl(connect(mapStateToProps)(RewardWalletBannerCard));
